'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CanvasContext = function CanvasContext() {
  _classCallCheck(this, CanvasContext);

  this.x = 0;
  this.y = 0;
  this.width = 128;
  this.height = 128;
  this.scale = 1;
  this.rotation = 0;
};

var CanvasBuffer = function () {
  function CanvasBuffer(element, args) {
    _classCallCheck(this, CanvasBuffer);

    var fragment = document.createDocumentFragment();

    this.image = args.image ? args.image : null;

    this.canvas = document.createElement('canvas');
    this.canvas.width = 128;
    this.canvas.height = 128;

    this.context = null;

    fragment.appendChild(this.canvas);

    element.appendChild(fragment);
  }

  _createClass(CanvasBuffer, [{
    key: 'getImage',
    value: function getImage() {
      return this.image;
    }
  }, {
    key: 'clearImage',
    value: function clearImage() {
      this.context = new CanvasContext();

      var graphicsContext = this.canvas.getContext('2d');

      graphicsContext.fillStyle = '#fff';
      graphicsContext.fillRect(0, 0, this.canvas.width, this.canvas.height);

      this.image = null;
    }
  }, {
    key: 'setImage',
    value: function setImage(imageElement) {
      this.context = new CanvasContext();

      var s = imageElement.width > imageElement.height ? imageElement.width / imageElement.height : imageElement.height / imageElement.width;
      this.context.width = imageElement.width < imageElement.height ? imageElement.width * s : imageElement.height * s;
      this.context.height = this.context.width;
      this.context.x = imageElement.width / 2 - this.context.width / 2;
      this.context.y = imageElement.height / 2 - this.context.height / 2;

      this.renderImage(imageElement);

      this.image = this.canvas.toDataURL('image/jpeg', 0.9);
    }
  }, {
    key: 'rotateImage',
    value: function rotateImage(imageElement) {
      this.context.rotation = (this.context.rotation + Math.PI / 2) % (Math.PI * 2);
      this.renderImage(imageElement);

      this.image = this.canvas.toDataURL('image/jpeg', 0.9);
    }
  }, {
    key: 'renderImage',
    value: function renderImage(img) {
      var graphicsContext = this.canvas.getContext('2d');

      graphicsContext.fillStyle = '#fff';
      graphicsContext.fillRect(0, 0, this.canvas.width, this.canvas.height);
      graphicsContext.translate(this.canvas.width / 2, this.canvas.height / 2);
      graphicsContext.rotate(this.context.rotation);
      graphicsContext.translate(-this.canvas.width / 2, -this.canvas.height / 2);
      graphicsContext.drawImage(img, this.context.x, this.context.y, this.context.width, this.context.height, 0, 0, this.canvas.width, this.canvas.height);
      graphicsContext.setTransform(1, 0, 0, 1, 0, 0);
    }
  }]);

  return CanvasBuffer;
}();

var ImagePickerControl = function () {
  function ImagePickerControl(element, args) {
    var _this = this;

    _classCallCheck(this, ImagePickerControl);

    this.element = element;
    var fragment = document.createDocumentFragment();
    this.image = args.image ? args.image : null;
    this.img = null;

    var dropHandler = function dropHandler(event) {
      event.preventDefault();
      if (event.dataTransfer.items && event.dataTransfer.items.length > 0) {
        var result = null;
        var url = null;

        for (var i = 0; i < event.dataTransfer.items.length; i++) {
          if (event.dataTransfer.items[i].type.indexOf('image/') === 0) {
            result = event.dataTransfer.items[i];
            break;
          }

          if (!url && event.dataTransfer.items[i].type === 'text/plain') {
            url = event.dataTransfer.items[i];
          }
        }

        if (result) {
          _this.setImage(URL.createObjectURL(result.getAsFile()));
        } else if (url) {
          url.getAsString(function (s) {
            _this.setImage(s);
          });
        }
      }
    };

    var dragoverHandler = function dragoverHandler(event) {
      event.preventDefault();
    };

    var filePickerChanged = function filePickerChanged(event) {
      if (event.target.files && event.target.files.length > 0) {
        _this.setImage(URL.createObjectURL(event.target.files[0]));
      }
    };

    this.filePicker = document.createElement('input');
    this.filePicker.type = 'file';
    this.filePicker.accept = 'image/*';
    this.filePicker.className = 'invisible';
    this.filePicker.onchange = filePickerChanged;

    this.canvas = new CanvasBuffer(fragment, {});

    this.imageLoaded = function () {
      _this.canvas.setImage(_this.img);
      _this.image = _this.canvas.getImage();
    };

    this.imageFailed = function () {
      if (_this.img) {
        _this.element.removeChild(_this.img);
      }

      _this.img = null;
      alert('Kon afbeelding niet laden. Kies een andere of probeer opnieuw.');
    };

    if (this.image) {
      this.img = document.createElement('img');
      this.img.src = this.image;
      this.img.className = 'invisible';
      this.img.crossOrigin = 'anonymous';
      this.img.onload = this.imageLoaded;
      this.img.onerror = this.imageFailed;

      fragment.appendChild(this.img);
    }

    this.element.ondrop = dropHandler;
    this.element.ondragover = dragoverHandler;

    this.element.appendChild(fragment);
  }

  _createClass(ImagePickerControl, [{
    key: 'getImage',
    value: function getImage() {
      return this.image;
    }
  }, {
    key: 'setImage',
    value: function setImage(newImage) {
      if (this.img) {
        if (this.img.src) {
          URL.revokeObjectURL(this.img.src);
        }

        this.element.removeChild(this.img);
        this.img = null;
      }

      this.img = document.createElement('img');
      this.img.src = newImage;
      this.img.className = 'invisible';
      this.img.crossOrigin = 'anonymous';
      this.img.onload = this.imageLoaded;
      this.img.onerror = this.imageFailed;

      this.element.appendChild(this.img);
    }
  }, {
    key: 'rotateImage',
    value: function rotateImage() {
      if (this.img) {
        this.canvas.rotateImage(this.img);
      }
    }
  }, {
    key: 'clearImage',
    value: function clearImage() {
      if (this.img) {
        if (this.img.src) {
          URL.revokeObjectURL(this.img.src);
        }

        this.element.removeChild(this.img);
        this.img = null;
      }

      this.image = null;
      this.canvas.clearImage();
    }
  }, {
    key: 'onselect',
    value: function onselect() {
      this.filePicker.click();
    }
  }, {
    key: 'pasteHandler',
    value: function pasteHandler(event) {
      event.preventDefault();
      if (event.clipboardData.items && event.clipboardData.items.length > 0) {
        var result = null;

        for (var i = 0; i < event.clipboardData.items.length; i++) {
          if (event.clipboardData.items[i].type.indexOf('image/') === 0) {
            result = event.clipboardData.items[i];
            break;
          }
        }

        if (result) {
          this.setImage(URL.createObjectURL(result.getAsFile()));
        }
      }
    }
  }]);

  return ImagePickerControl;
}();

exports.default = ImagePickerControl;


//////////////////
// WEBPACK FOOTER
// ./js/lib/ui/ImagePickerControl.js
// module id = 39
// module chunks = 0